module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "mobile-btn",
    class: {
      init: _vm.isInit, open: _vm.mobileMenuOpen
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuOpen = !_vm.mobileMenuOpen
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('router-link', {
    staticClass: "logo-right",
    attrs: {
      "active-class": "active",
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/logo-w.png")
    }
  }), _c('img', {
    attrs: {
      "src": require("./img/logo-g.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu",
    class: {
      open: _vm.mobileMenuOpen
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./img/logo.png")
    },
    on: {
      "click": function($event) {
        _vm.mobileMenuOpen = false
      }
    }
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "to": "/clients"
    }
  }, [_vm._v("Clients"), _c('span', {
    on: {
      "click": function($event) {
        _vm.mobileMenuOpen = false
      }
    }
  }, [_vm._v("Clients")])]), _vm._v(" "), _c('img', {
    staticClass: "zig-zag",
    attrs: {
      "src": require("./img/zig-zag.png")
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "to": "/services"
    }
  }, [_vm._v("Services"), _c('span', {
    on: {
      "click": function($event) {
        _vm.mobileMenuOpen = false
      }
    }
  }, [_vm._v("Services")])]), _vm._v(" "), _c('img', {
    staticClass: "zig-zag",
    attrs: {
      "src": require("./img/zig-zag.png")
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "to": "/about"
    }
  }, [_vm._v("About"), _c('span', {
    on: {
      "click": function($event) {
        _vm.mobileMenuOpen = false
      }
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('img', {
    staticClass: "zig-zag",
    attrs: {
      "src": require("./img/zig-zag.png")
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "to": "/contact"
    }
  }, [_vm._v("Contact"), _c('span', {
    on: {
      "click": function($event) {
        _vm.mobileMenuOpen = false
      }
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('img', {
    staticClass: "zig-zag",
    attrs: {
      "src": require("./img/zig-zag.png")
    }
  }), _vm._v(" "), _vm._m(2)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "leave": _vm.leave,
      "enter": _vm.enter
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "black"
  }, [_c('span', [_vm._v("Menu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circle"
  }, [_c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social"
  }, [_vm._v("\n        Find us on"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/plan.a.ideas/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/social-fb.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/plan_a_ideas",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/social-tw.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/plana.digital",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/social-ig.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/plan-a-for-digital",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./img/social-in.png")
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:hello@plan-a.co.in"
    }
  }, [_vm._v("hello@plan-a.co.in"), _c('span', [_vm._v("hello@plan-a.co.in")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5185b6ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 161
// module chunks = 0